import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminHeader, Card, StatCard, Empty } from "@/components/admin/ui";
import { formatINR } from "@/lib/format";
import { IndianRupee, ShoppingCart, TrendingUp, Package } from "lucide-react";

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then(({ data }) => setD(data)); }, []);
  if (!d) return null;

  const hasData = d.orderCount > 0;

  return (
    <div>
      <AdminHeader title="Analytics" subtitle="Sales & performance insights" />
      {!hasData ? (
        <Card className="p-8"><Empty text="Not enough data yet. Analytics populate as real orders come in." /></Card>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-6">
            <StatCard label="Total Sales" value={formatINR(d.totalSales)} icon={IndianRupee} tone="emerald" />
            <StatCard label="Orders" value={d.orderCount} icon={ShoppingCart} tone="slate" />
            <StatCard label="Avg Order Value" value={formatINR(d.averageOrderValue)} icon={TrendingUp} tone="amber" />
            <StatCard label="Units Sold" value={d.productsSold} icon={Package} tone="slate" />
          </div>
          <div className="grid lg:grid-cols-2 gap-6">
            <Card className="p-5">
              <h3 className="font-semibold text-slate-900 mb-4">Top Products</h3>
              {d.topProducts.length === 0 ? <Empty /> : (
                <div className="space-y-2">
                  {d.topProducts.map((p, i) => (
                    <div key={i} className="flex items-center justify-between text-sm p-2 rounded-lg hover:bg-slate-50">
                      <span className="text-slate-700 line-clamp-1">{i + 1}. {p.name}</span>
                      <span className="font-mono font-semibold">{p.units} units</span>
                    </div>
                  ))}
                </div>
              )}
            </Card>
            <Card className="p-5">
              <h3 className="font-semibold text-slate-900 mb-4">Customer Growth</h3>
              {d.customerGrowth.length === 0 ? <Empty /> : (
                <div className="space-y-2">
                  {d.customerGrowth.map((g, i) => (
                    <div key={i} className="flex items-center justify-between text-sm">
                      <span className="text-slate-500">{g.month}</span>
                      <div className="flex items-center gap-2 flex-1 ml-4">
                        <div className="flex-1 h-2 rounded-full bg-slate-100"><div className="h-full rounded-full bg-amber-500" style={{ width: `${Math.min(100, g.count * 20)}%` }} /></div>
                        <span className="font-mono w-8 text-right">{g.count}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Card>
          </div>
        </>
      )}
    </div>
  );
}
